module.exports = "<form>\r\n  <spk-card title=\"Search Users\">\r\n    <spk-checkbox wrappedClass=\"pull-right\" name=\"showInactive\" [(model)]=\"showInactive\" (modelChange)=\"setFilterSpecification()\"></spk-checkbox>\r\n    <spk-search-grid #grid defaultSortProperty=\"LastName, FirstName\" list=\"UserSearchRow\" [csvExport]=\"true\" [leftLinks]=\"leftLinks\" [filter]=\"filter\"></spk-search-grid>\r\n  </spk-card>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/security/users/users/users.component.html
// module id = ./src/app/components/security/users/users/users.component.html
// module chunks = main